"use client";
import { useDispatch } from "react-redux";
import { Form, Input, Checkbox, Button } from "antd";
import {
  MobileOutlined,
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import Cookies from "js-cookie";
import UserService from "@/services/api/UserService";
import { TOKEN_STORE_KEY } from "@/constants/storage";
import { setUser } from "@/redux/slices/userSlice";
import { FaArrowRight } from "react-icons/fa6";
import { loginAfterAuthSuccess } from "@/helpers/auth";
import { openDrawer } from "@/redux/slices/authDrawerSlice";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { useState } from "react";
import SubmitButton from "@/components/common/Button/SubmitButton";

const LoginForm = ({ toast, setDrawerOpen, pageType, pathName }) => {
  console.log("pathName", pathName);
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const onFinish = async (values) => {
    setLoading(true);
    try {
      await loginAfterAuthSuccess(
        values,
        dispatch,
        toast,
        setDrawerOpen,
        router,
        pageType,
        pathName
      );
    } catch (error) {
      // console.error("Login failed x:", error?.response?.data?.message);

      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        setErrorMessage(backendMessage);
      } else {
        setErrorMessage("লগইন করার সময় সমস্যা হয়েছে");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
    const isTouched = form.isFieldsTouched(true);
    setIsFormValid(!hasErrors && isTouched);
  };

  return (
    <>
      <h2 className="second-title">স্বাগতম তোমাকে</h2>
      {errorMessage && (
        <h2 className="second-title !text-red-500 mb-4">{errorMessage}</h2>
      )}
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="login-reg-form"
        onFieldsChange={handleFormChange}
      >
        <Form.Item
          name="phone"
          rules={[
            { required: true, message: "ফোন নাম্বার দাও" },
            {
              pattern: /^0\d{10}$/,
              message: "সঠিক ১১ সংখ্যার ফোন নাম্বার দিন (০ দিয়ে শুরু)",
            },
          ]}
        >
          <Input
            size="large"
            autoComplete="off"
            placeholder="ফোন নাম্বার"
            className="login-form-input"
            addonBefore="+88"
            maxLength={11}
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "পাসওয়ার্ড দাও" }]}
        >
          <Input.Password
            size="large"
            placeholder="পাসওয়ার্ড"
            autoComplete="off"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
            className="login-form-input"
          />
        </Form.Item>
        <div className="flex justify-between flex-wrap gap-3 items-center text-base mb-4 login-text-wrap">
          <Checkbox className="pass-save-text">পাসওয়ার্ড সেভ রাখো</Checkbox>
          <Link href="/forget-password" className="pass-read-text">
            পাসওয়ার্ড ভুলে গেছো?
          </Link>
        </div>
        <Form.Item>
          <SubmitButton
            text="লগ ইন"
            loading={loading}
            disabled={!isFormValid}
          />
        </Form.Item>

        <p className="not-account">
          তোমার একাউন্ট নেই?{" "}
          <a
            href="#"
            onClick={() => dispatch(openDrawer("register"))}
            className="new-registation"
          >
            রেজিস্ট্রেশন করো
          </a>
        </p>
      </Form>
    </>
  );
};

export default LoginForm;
